

import React from 'react'
import save_rent from '../../save-rent.png'
import { Link } from 'react-router-dom'
import { FaBolt} from 'react-icons/fa6'
 //  bg-gradient-to-r from-green-200  via-white to-green-200
export default function Hero() {
  return (
    <div id='hero' className='lg:h-[30em] w-[100%] lg:flex lg:flex-col  mb-[10em] lg:mb-[30em]' >

      <div className="hero_text mt-[3em]  lg:w-1/2 m-auto">

              <div className="font-[Lexend] m-auto justify-center py-[.25em] flex  text-sm mt-[.em] w-[25em] px-[1.75em] leading-[2em] lg:m-auto border rounded-full border-black mb-[3em]">
                <FaBolt className='text-black mt-[.4em] lg:-ml-1'/>
                <p className='font-extralight'>Fast and reliable way to pay rent </p>
                  </div>
        

        <p className='text-3xl  font-black pr-[1em] ml-[1.75em] leading-[1.5em] lg:ml-[5.1em] mt-[1.25em] font-[Satoshi] w-[90%] lg:w-[70%] lg:-indent-10'>
        Start paying Rent with Ease, Empower Your Future
          </p>
        <p className="font-[Lexend] text-sm w-[85%]  mt-[1em]  pr-[1.75em] leading-[2em] lg:ml-[5em] ml-[2.75em] md:ml-[3.4em] -indent-30">Building a platform where we manage rent for landlords To make paying rent easier for tenants and reduce pressure.</p>
        
         <div className='lg:ml-[9em] ml-[2em] mt-[.25em]'>

         <Link to="/Auth/signup" className='text-white px-[.9em] relative top-[2em] py-[1em] ml-[1.75em] lg:ml-[2em] rounded-full mt-[10em] lg:h-[3em] lg:w-[10em] h-[4em] text-sm font-[Satoshi] font-semibold bg-green-500'>Get Started Now</Link>

        <Link  className='text-black px-[.9em] relative top-[2em] py-[1em] ml-[1.75em] lg:ml-[2em] rounded-full mt-[10em] lg:h-[3em] lg:w-[10em] h-[4em] text-sm font-[Satoshi] font-bold bg-white border border-black'>How it works</Link> 
        
         </div>
     
      </div>

    `  <div className="hero_text lg:w-[90%] h-full hidden lg:block ">
        <img src={save_rent} alt="hero" className='bg-white object-cover lg:w-[95%] mt-[3em] ml-[2.5em] lg:ml-[6em] mr-[2em] h-[30em] '></img>
         </div>`
    </div>
  )
}


